import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../SvgProps';

const RepairsIcon = ({ color = '#2B78CA' }: Props) => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path
      d="M12.2497 5.25047C12.097 5.40625 12.0115 5.61568 12.0115 5.83381C12.0115 6.05193 12.097 6.26136 12.2497 6.41714L13.5831 7.75047C13.7388 7.90316 13.9483 7.98869 14.1664 7.98869C14.3845 7.98869 14.594 7.90316 14.7497 7.75047L17.3381 5.16297C17.6047 4.89464 18.0572 4.97964 18.1572 5.34464C18.409 6.26037 18.3948 7.22886 18.1162 8.1368C17.8376 9.04474 17.3063 9.85456 16.5842 10.4715C15.8622 11.0885 14.9794 11.487 14.0391 11.6205C13.0988 11.7541 12.14 11.617 11.2747 11.2255L4.68307 17.8171C4.35155 18.1485 3.90196 18.3347 3.43319 18.3346C2.96443 18.3345 2.5149 18.1482 2.18349 17.8167C1.85208 17.4852 1.66594 17.0356 1.66602 16.5668C1.66609 16.0981 1.85238 15.6485 2.1839 15.3171L8.77557 8.72547C8.38402 7.86023 8.24699 6.90137 8.38052 5.9611C8.51404 5.02082 8.91259 4.13801 9.52954 3.41598C10.1465 2.69395 10.9563 2.16256 11.8642 1.88399C12.7722 1.60542 13.7407 1.59119 14.6564 1.84297C15.0214 1.94297 15.1064 2.39464 14.8389 2.66297L12.2497 5.25047Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
  
);

export default RepairsIcon;
